export const BATCHES_START_SHIPMENT_PURCHASE = 'BATCHES_START_SHIPMENT_PURCHASE';
export const startBatchesShipmentPurchase = (fulfillmentPlanSetId, shouldPrint) => ({
  type: BATCHES_START_SHIPMENT_PURCHASE,
  fulfillmentPlanSetId,
  shouldPrint,
});

export const VALIDATE_BATCHES_SUCCESS = 'VALIDATE_BATCHES_SUCCESS';
export const validateBatchesSuccess = (jobIdsToFpSetIdMap, jobGuids) => ({
  type: VALIDATE_BATCHES_SUCCESS,
  jobIdsToFpSetIdMap,
  jobGuids,
});

export const VALIDATE_BATCHES_RETRY = 'VALIDATE_BATCHES_RETRY';
export const validateBatchesRetry = (fulfillmentPlanSetId) => ({
  type: VALIDATE_BATCHES_RETRY,
  fulfillmentPlanSetId,
});

export const VALIDATE_BATCHES_FAILURE = 'VALIDATE_BATCHES_FAILURE';
export const validateBatchesFailure = (error) => ({
  type: VALIDATE_BATCHES_FAILURE,
  error,
});

export const COST_REVIEW_BATCHES_RETRY = 'COST_REVIEW_BATCHES_RETRY';
export const costReviewBatchesRetry = (fulfillmentPlanSetId) => ({
  type: COST_REVIEW_BATCHES_RETRY,
  fulfillmentPlanSetId,
});

export const COST_REVIEW_BATCHES_REQUEST = 'COST_REVIEW_BATCHES_REQUEST';
export const costReviewBatches = (fulfillmentPlanSetId) => ({
  type: COST_REVIEW_BATCHES_REQUEST,
  fulfillmentPlanSetId,
});

export const COST_REVIEW_BATCHES_SUCCESS = 'COST_REVIEW_BATCHES_SUCCESS';
export const costReviewBatchesSuccess = (fulfillmentPlanSetId, jobIdsToFpSetIdMap) => ({
  type: COST_REVIEW_BATCHES_SUCCESS,
  fulfillmentPlanSetId,
  jobIdsToFpSetIdMap,
});

export const BATCHES_OPEN_COST_REVIEW = 'BATCHES_OPEN_COST_REVIEW';
export const openBatchesCostReviewModal = (fulfillmentPlanSetId, costReviewSummary, recommendationSummary, appliedSavings) => ({
  type: BATCHES_OPEN_COST_REVIEW,
  fulfillmentPlanSetId,
  costReviewSummary,
  recommendationSummary,
  appliedSavings,
});

export const BATCHES_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED = 'BATCHES_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED';
export const walletPurchaseAmountChanged = (fulfillmentPlanSetId, walletProviderCost, amount) => ({
  type: BATCHES_PURCHASE_WALLET_PURCHASE_AMOUNT_CHANGED,
  fulfillmentPlanSetId,
  walletProviderCost,
  amount,
});

export const BATCHES_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED = 'BATCHES_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED';
export const providerPurchaseAmountChanged = (fulfillmentPlanSetId, provider, amount) => ({
  type: BATCHES_PURCHASE_PROVIDER_PURCHASE_AMOUNT_CHANGED,
  fulfillmentPlanSetId,
  provider,
  amount,
});

export const BATCHES_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED = 'BATCHES_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED';
export const insurancePurchaseAmountChanged = (fulfillmentPlanSetId, provider, amount) => ({
  type: BATCHES_PURCHASE_INSURANCE_PURCHASE_AMOUNT_CHANGED,
  fulfillmentPlanSetId,
  provider,
  amount,
});

export const CREATE_LABELS_FOR_BATCHES_SUCCESS = 'CREATE_LABELS_FOR_BATCHES_SUCCESS';
export const createLabelsForBatchesSuccess = (fulfillmentPlanSetId, jobIdsToFpSetIdMap, notoId) => ({
  type: CREATE_LABELS_FOR_BATCHES_SUCCESS,
  fulfillmentPlanSetId,
  jobIdsToFpSetIdMap,
  notoId,
});

export const BATCHES_CLEANUP_BATCH_DATA = 'BATCHES_CLEANUP_BATCH_DATA';
export const cleanUpBatchFromState = (fulfillmentPlanSetId) => ({
  type: BATCHES_CLEANUP_BATCH_DATA,
  fulfillmentPlanSetId,
});

export const BATCHES_PURCHASE_SET_SHIP_DATE = 'BATCHES_PURCHASE_SET_SHIP_DATE';
export const batchesPurchaseSetShipDate = (shipDate) => ({
  type: BATCHES_PURCHASE_SET_SHIP_DATE,
  shipDate,
});

export const BATCH_STATUS_MODAL_CLOSED = 'BATCHES_PURCHASE_CANCEL';
export const batchStatusModalClosed = () => ({
  type: BATCH_STATUS_MODAL_CLOSED,
});

export const SET_BATCHES_LBS_MODAL_ID = 'SET_BATCHES_LBS_MODAL_ID';
export const setBatchesLbsModalId = (lbsModalId = '') => ({
  type: SET_BATCHES_LBS_MODAL_ID,
  lbsModalId,
});

export const BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS = 'BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS';
export const batchCostReviewApplyRecommendations = ({
  fulfillmentPlanSetId,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
}) => ({
  type: BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS,
  fulfillmentPlanSetId,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
});

export const BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS = 'BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS';
export const batchCostReviewApplyRecommendationsSuccess = (fulfillmentPlanSetId) => ({
  type: BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS,
  fulfillmentPlanSetId,
});

export const BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR = 'BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR';
export const batchCostReviewApplyRecommendationsError = (fulfillmentPlanSetId) => ({
  type: BATCH_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR,
  fulfillmentPlanSetId,
});
